export const ProfessionsMap = new Map<number[], string>([
		[[1, 101], 'chiropractor'],
		[[2], 'physiotherapy'],
		[[3], 'reflexology'],
		[[4, 6, 8], 'psychologist'],
		[[5, 21], 'podiatrist'],
		[[9], 'masseuse'],
		[[11, 67], 'acupuncturist'],
		[[13], 'dietitian'],
		[[15], 'dentist'],
		[[17, 20, 124, 126], 'psychiatrist'],
		[[23], 'therapist'],
		[[61], 'anesthesiologist'],
		[[91, 292], 'andet'],
		[[125], 'paediatri']
	]
);
